import React from 'react';
import styled from 'styled-components';
import ExhibitionColumnInfo from './component/exhibitions/ExhibitionColumnInfo';
import ExhibitionList from './component/exhibitions/ExhibitionList';
import PageAboutExhibition from './component/exhibitions/PageAboutExhibition';
import ExhibitionRouteGuard from './component/exhibitions/ExhibitionRouteGuard';

const AdminExhibitions: React.FC = () => (
  <ExhibitionContainer>
    <ExhibitionRouteGuard />
    <ExhibitionColumnInfo />
    <ExhibitionList />
    <PageAboutExhibition />
  </ExhibitionContainer>
);

const ExhibitionContainer = styled.main`
  width: 96%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: calc(8vh);
  margin-bottom: 5.8vh;
  overflow: hidden;
`;

export default AdminExhibitions;
